export default __webpack_public_path__ + "static/media/dashboard 1.cb8fa7f8.svg";